import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { LanguageProvider } from './i18n/LanguageProvider';
import * as serviceWorker from './serviceWorker';

//import './App.css';
import './assets/scss/style.scss';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <LanguageProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LanguageProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
